var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooterIcon1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9906 10.1872C18.6474 9.16565 16.9711 8.6831 15.2921 8.8383H13.8331V21.1561H16.3785C18.2071 21.1561 19.5475 20.6199 20.4026 19.5447C21.3338 18.2269 21.7853 16.6297 21.6866 15.0183C21.6866 12.7552 21.1222 11.1438 19.9906 10.1844V10.1872Z",
    fill: "#2F2F2F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6058 0H9.39705C4.20751 0 0 4.20751 0 9.39705V20.603C0 25.7925 4.20751 30 9.39705 30H20.603C25.7925 30 30 25.7925 30 20.603V9.39705C30.0028 4.20751 25.7953 0 20.6058 0ZM5.81601 12.4278H8.30213V14.9139H5.81601V12.4278ZM8.37833 22.2961H5.8922V19.81H8.37833V22.2961ZM21.9688 21.1363C20.4901 22.5275 18.4216 23.2245 15.769 23.2245H11.9848C11.8183 23.2443 11.6518 23.202 11.5163 23.106C11.4204 22.9706 11.378 22.8041 11.3978 22.6376V7.36525C11.3809 7.2044 11.4232 7.04073 11.5163 6.9081C11.649 6.80369 11.8183 6.75571 11.9848 6.77829H15.769C18.4244 6.77829 20.4901 7.48095 21.9688 8.8891C23.4475 10.2944 24.1868 12.3347 24.1868 15.0014C24.1868 17.6992 23.4475 19.7451 21.9688 21.1363Z",
    fill: "#2F2F2F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterIcon1);
export default __webpack_public_path__ + "static/media/footer_icon1.402cb7560a39e352f09e61339779d3cd.svg";
export { ForwardRef as ReactComponent };